import React from 'react';

import { Button } from 'react-bootstrap';

import { ModalContext } from 'components/shared/Modal/ModalContext';

interface IModalButtonProps {
    as?: any;
    className?: string;
    disabled: boolean;
    disableOnSubmit: boolean;
    onClick?: (e: React.MouseEvent) => void;
    to?: string;
    href?: string;
    type: 'button' | 'submit';
    variant?: string;
    target?: string;
}

export const ModalButton = (
    {
        as,
        children,
        className,
        disabled,
        disableOnSubmit,
        onClick,
        type,
        variant,
        to,
        href,
        target,
    }: React.PropsWithChildren<IModalButtonProps>
) => {
    const {isSubmitting} = React.useContext(ModalContext);

    return (
        <Button
            block={true}
            as={as}
            className={`Modal__button ${className || ''}`}
            disabled={disabled || (disableOnSubmit && isSubmitting)}
            onClick={onClick}
            type={type}
            variant={variant}
            to={to}
            href={href}
            target={target}
        >
            {children}
        </Button>
    );
};

ModalButton.defaultProps = {
    disabled: false,
    disableOnSubmit: true,
    type: 'button',
};
